import { ComponentProps, useContext, useEffect } from 'react';
import { TokenAccessor } from '../../types/API';

import { LtiViewer } from '../lti-viewer';
import { LtiResourceContext } from './context/LtiResourceContext';
import MaterialDialogHeader from '../../../../pages/material/components/MaterialDialogHeader';
import ModalContext from '../../../../contexts/ModalContext';
import Dialog from '@pelckmans/elementis/components/dialog';

export type Platform = 'Pelckmans Basisonderwijs' | 'Pelckmans Portail' | 'Pelckmans Portaal' | 'Pelckmans NT2';

type Props = {
  id: string;
  loginUrl: string;
  onClose: () => void;
  tokenAccessor: TokenAccessor;
  studioGroup: string;
  'aria-label': string;
  headerProps: Pick<ComponentProps<typeof MaterialDialogHeader>, 'title' | 'tags' | 'titleTooltip'>;
};

// This modal can be used for multiple Lti features: deep linking, lti resource link launch,...
export function LtiModal({
  loginUrl,
  onClose,
  tokenAccessor,
  id = 'lti-modal',
  studioGroup,
  headerProps,
  'aria-label': ariaLabel,
}: Props): JSX.Element {
  const { closeModal } = useContext(ModalContext);

  const [, setLtiResource] = useContext(LtiResourceContext);

  useEffect(() => {
    type MessageEventData = { messageType: string; parameters: Record<string, string> };
    const handlePostMessage = (e: MessageEvent<MessageEventData>): void => {
      if (e.data.messageType !== 'LTI') return;

      setLtiResource(e.data.parameters.jwt);
      onClose();
    };

    window.addEventListener('message', handlePostMessage);
    return (): void => window.removeEventListener('message', handlePostMessage);
  }, [onClose, setLtiResource]);

  function handleClose() {
    closeModal(id);
    onClose();
  }

  return (
    <Dialog id={id} modal onClose={handleClose} size="full" aria-label={ariaLabel}>
      <MaterialDialogHeader
        title={headerProps.title}
        tags={headerProps.tags}
        onClose={handleClose}
        titleTooltip={headerProps.titleTooltip}
      />
      <Dialog.Body className="exercise-modal-section">
        <LtiViewer
          iframeTitle={headerProps.title}
          loginUrl={loginUrl}
          studioGroup={studioGroup}
          tokenAccessor={tokenAccessor}
        />
      </Dialog.Body>
    </Dialog>
  );
}
